import React from "react";
import ArrowButton from "../ArrowButton";
import { ReactComponent as HomePagePopupIcon } from "../../assets/images/svg/homePagePopupIcon.svg";
import UserStore from "../../store/UserStore";
import { getAsOfDate, getDisplayDate } from "../../utils/functions";

function HomePopup({ onClick }) {
  return (
    <div className="home_popup_container">
      <HomePagePopupIcon />
      <p className="home_popup_info_text">
        Please be aware that we are in the process of updating, therefore data
        is limited and will be available as on{" "}
        {getDisplayDate(
          getAsOfDate(UserStore.portfolio?.clientPortfolioReturn?.as_of_date)
        )}
      </p>
      <div className="home_page_popup_arrow_btn">
        <ArrowButton
          onClick={onClick}
          type={"next"}
          label={"Got it! Continue"}
          styleProp={{
            borderRadius: "15px",
          }}
        />
      </div>
    </div>
  );
}

export default HomePopup;
